module.exports = __webpack_public_path__ + "img/wrcsfw-hzjd.785b75cc.png";